var render, staticRenderFns
import script from "./tdt-slot-marker.vue?vue&type=script&lang=js&"
export * from "./tdt-slot-marker.vue?vue&type=script&lang=js&"
import style0 from "./tdt-slot-marker.vue?vue&type=style&index=0&id=99f2c8dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports